import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const mensajeInternoImporterSelectors = importerSelectors(
  'mensajeInterno.importer',
);

export default mensajeInternoImporterSelectors;
